import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useState } from "react";
import { Label, Radio } from "theme-ui";
import { FontWeight } from "../../index";
const textCommonStyles = (isSelected) => ({
    borderBottom: "1px solid",
    borderColor: isSelected ? "grey.0" : "transparent",
    fontWeight: isSelected ? FontWeight.textBold : FontWeight.textRegular,
    pb: 8
});
const inStockStyling = ({ isSelected, labelClicked }) => ({
    text: Object.assign({}, textCommonStyles(isSelected)),
    label: {
        justifyContent: "center",
        cursor: "pointer",
        ":focus-within": {
            outlineStyle: labelClicked ? "none" : "auto"
        },
        "svg, input:checked ~ svg": {
            display: "none"
        }
    }
});
const outOfStockStyling = ({ isSelected, labelClicked, disableOutOfStock }) => ({
    text: Object.assign({}, textCommonStyles(isSelected)),
    label: {
        justifyContent: "center",
        cursor: disableOutOfStock ? "not-allowed" : "pointer",
        ":focus-within": {
            outlineStyle: labelClicked ? "none" : "auto"
        },
        "svg, input:checked ~ svg": {
            display: "none"
        }
    }
});
export const SizeButtonNew = ({ isSelected, size, backgroundColors, disableOutOfStock }) => {
    const { isInStock, label, onSelect = () => { } } = size;
    const className = `size-selector-${isInStock ? "in" : "out-of"}-stock`;
    const [labelClicked, setLabelClicked] = useState(false);
    const style = isInStock
        ? inStockStyling({ isSelected, labelClicked })
        : outOfStockStyling({
            isSelected,
            backgroundColors,
            labelClicked,
            disableOutOfStock
        });
    return (_jsxs(Label, { id: `size-selector-${label}`, className: className, onMouseUp: () => setLabelClicked(true), onBlur: () => setLabelClicked(false), sx: style.label, marginRight: 40, children: [_jsx(Radio, { name: "size-radio", value: "true", defaultChecked: isSelected, disabled: !isInStock && disableOutOfStock, onClick: () => {
                    if (isInStock || !disableOutOfStock) {
                        return onSelect();
                    }
                } }), _jsx("span", { sx: style.text, children: label })] }));
};
//# sourceMappingURL=SizeButtonNew.js.map